import React, { useContext, useEffect } from "react";

import {
  Context,
  fetchClasses,
  fetchKlassIdsWithActiveLearningMaterials,
} from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import SelectClass from "../../../templates/Select/Class";

export default () => {
  const { state, dispatch } = useContext(Context);
  const queryParams = parseQueryParams();
  const isActiveLearningParam = queryParams["isActiveLearning"] === "true";
  const classes = isActiveLearningParam
    ? state.klass_ids_with_active_learning_materials
    : state.classes;

  useEffect(() => {
    dispatch(fetchClasses());
    dispatch(fetchKlassIdsWithActiveLearningMaterials());
  }, [dispatch]);

  return <SelectClass classes={classes} forward forwardData />;
};
